export enum SeoPagesEnum {
  termsAndCondition = 'TERMS_CONDITIONS',
  privacyPolicy = 'PRIVACY_POLICY',
  contactUs = 'CONTACT_US',
  aboutUs = 'ABOUT_US',
  vouchersHowTo = 'VOUCHERS_HOW_TO',
  privateBooking = 'PRIVATE_BOOKINGS',
  foodMenu = 'FOOD_MENU',
  offers = 'OFFERS',
  cinemas = 'CINEMAS',
  experiences = 'EXPERIENCES',
  finder = 'FINDER',
  home = 'HOME',
}
